
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/claims-processing",
      function () {
        return require("private-next-pages/en/ai/claims-processing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/claims-processing"])
      });
    }
  